import { createContext } from 'react'

/** A tap on a card's button, outside a live conversation: which action, and its data (the product it belongs to…). */
export interface CardActionEvent {
  id: string
  data: Record<string, unknown>
  sourceMessageUlid?: string
}

/** What the page that drew the card says happened: shown on the button / as the card's toast. */
export interface CardActionResult {
  success: boolean
  message?: string
}

/**
 * Set by whoever draws cards with no conversation behind them (the templates render SDK): a card's buttons go to
 * this handler instead of the widget's dispatch endpoint. Absent in the widget itself.
 */
export const CardActionContext = createContext<((e: CardActionEvent) => Promise<CardActionResult | void> | CardActionResult | void) | null>(null)
